import { appAxios } from "./appService";

export default {
  async getAllSubscribers() {
    const response = await appAxios.get("/get-subscribers");
    return response.data;
  }
};
